import { BestOfWeddingsExpandedBadge } from '@components/bow-badge/bow-expanded-badge';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import { ScreenReaderOnly } from '@xo-union/ui-accessibility';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-scroll';
import { SearchConstants } from '../../../../../../../settings';
import ReviewRating from '../review_rating';
import ReviewStars from '../review_stars';
import ReviewsCount from '../reviews_count';
import Styles from './styles.scss';

export default class ReviewSummary extends PureComponent {
	static propTypes = {
		vendor: PropTypes.shape({
			awards: PropTypes.array,
		}).isRequired,
		rating: PropTypes.number.isRequired,
		totalCount: PropTypes.number.isRequired,
		extendedBow: PropTypes.bool,
		starSize: PropTypes.string,
		showLabelCount: PropTypes.bool,
		showBow: PropTypes.bool,
		showNew: PropTypes.bool,
		collapseStarRating: PropTypes.bool,
	};

	static defaultProps = {
		extendedBow: false,
		showBow: true,
		showNew: false,
		collapseStarRating: false,
	};

	bowIcon() {
		if (this.props.extendedBow) {
			return <BestOfWeddingsExpandedBadge />;
		}

		return this.props.vendor.awards.length ? (
			<img
				className={Styles.bowIcon}
				alt={SearchConstants.BOW_FILTER_SLUG}
				src={`https://media-api.xogrp.com/images/${SearchConstants.BOW_MEDAL_MEDIA_ID}`}
			/>
		) : null;
	}

	getScreenReaderText() {
		const { rating, totalCount } = this.props;
		const shouldPluralize = totalCount !== 1;

		return `${rating} out of 5 stars and ${totalCount} review${
			shouldPluralize ? 's' : ''
		}`;
	}

	render() {
		const {
			rating,
			totalCount,
			starSize,
			showLabelCount,
			showBow,
			showNew,
			collapseStarRating,
		} = this.props;

		const displayIsNew = showNew && totalCount === 0;

		return (
			<div className={Styles.reviewSummaryWrapper}>
				{!displayIsNew && (
					<Link href="#navReviews" to="navReviews" smooth offset={-25}>
						<ScreenReaderOnly>{this.getScreenReaderText()}</ScreenReaderOnly>
						<ReviewStars
							overallRating={rating}
							size={starSize}
							isSingleStar={collapseStarRating}
						/>
						{rating > 0 && <ReviewRating overallRating={rating} />}
						{showLabelCount && (
							<span className={Styles.separatorCount}> · </span>
						)}
						<ReviewsCount
							reviewsCount={totalCount}
							showLabel={showLabelCount}
						/>
					</Link>
				)}
				{displayIsNew && (
					<TextBody size="md" className={Styles.reviewBadgeNew} bold>
						<Icon
							size="md"
							name="star-filled"
							className={Styles.starFillingColor}
							aria-label="new review"
						/>
						<span>New</span>
					</TextBody>
				)}
				{showBow && this.bowIcon()}
			</div>
		);
	}
}
